export default "__VITE_ASSET__CLInp2s$__"